import React, { useState } from "react";
import Button from "./Button";
import Modal from "./Modal";

const ModalButton = ({ disabled = false, buttonText = "Open Modal", title = "Modal Title", render }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	return (
		<>
			<Button disabled={disabled} onClick={openModal}>
				{buttonText}
			</Button>

			<Modal isOpen={isModalOpen} onClose={closeModal} title={title}>
				{render && render({ closeModal })}
			</Modal>
		</>
	);
};

export { Modal };
export default ModalButton;
